import React from "react";
import WakoWelcome from "../../../../assets/mascots/wako/Welcome.svg";
import MascotScreen from "../components/MascotScreen";

export default function StartStep({ onStart }) {
  return <MascotScreen image={WakoWelcome} imageAlt="Wako te da la bienvenida" eyebrow="Bienvenidos al Club Arawaks" title="Inicia tu registro" description="Te acompañaremos paso a paso y guardaremos tu avance automáticamente." actionLabel="Comenzar" onDone={onStart}/>;
}
